<section class="sectionGap faq" id="faq">
  <div class="container">
    <h2 class="section-title mx-auto text-center d-none d-lg-block">{{ 'faq.title' | translate }}</h2>
    <h2 class="font-40 fw-bold section-title d-block d-lg-none">{{ 'faq.mob_head' | translate }}</h2>

    <div class="row d-flex align-items-center justify-content-center">
      <div class="col-12 col-lg-10">
        <div class="faq-wrapper pt-4">
          <accordion [closeOthers]="true" [isAnimated]="true">
            @for (item of faqItems; track item; let i = $index) {
              <accordion-group>
                <div class="position-relative w-100 fw-medium d-flex justify-content-between" accordion-heading>
                  <span class="text-white font-14 font-sm-18">
                    {{ item.heading | translate }}
                  </span>
                  <img src="/assets/images/svg-icons/angle-down.svg" loading="lazy" class="icon pt-2" alt="arrow"
                    height="19" />
                  </div>
                  <div accordion-panel class="mt-0">
                    <span class="para fw-regular" [innerHTML]="item.content | translate"></span>
                  </div>
                </accordion-group>
              }
            </accordion>
          </div>
        </div>
      </div>
    </div>
  </section>
